import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/image/02.png';
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "commodity"
};
const _hoisted_3 = ["src"];
import { ref } from 'vue';
import ContactUs from "@/components/ContactUs.vue";
import { commodityList } from './json.js';
export default {
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commodityList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "box"
        }, [_createElementVNode("img", {
          src: item.bgc,
          alt: ""
        }, null, 8, _hoisted_3)]);
      }), 128))]), _createVNode(ContactUs)]);
    };
  }
};